module.exports = __webpack_public_path__ + "img/attribute-green.50fc7486.svg";